/**
 * Removes everything from the name before the src folder to make the filename deterministic
 */
const cleanedFilename = (filename: string): string =>
  filename.substring(filename.lastIndexOf('src/'));

export default cleanedFilename;
